<template>
    <v-container fluid>
        <v-row no-gutters class="pa-1">
            <v-col cols="12" sm="12" lg="4" class="pl-1 pr-1">
                <i-card-vertical headerTitle="icardHorizontal">
                    <template v-slot:body>
                    </template>
                </i-card-vertical>
            </v-col>
            <v-col cols="12" sm="12" lg="4" class="pl-1 pr-1">
                <i-card-vertical headerTitle="icardVertical">
                    <template v-slot:body>
                    </template>
                </i-card-vertical>
            </v-col>
            <v-col cols="12" sm="12" lg="4" class="pl-1 pr-1">
                <i-card-vertical headerTitle="idataTable">
                    <template v-slot:body>
                    </template>
                </i-card-vertical>
            </v-col>
        </v-row>
        <v-row no-gutters class="pa-1">
            <v-col cols="12" sm="12" lg="4" class="pl-1 pr-1">
                <i-card-vertical headerTitle="idialog">
                    <template v-slot:body>
                    </template>
                </i-card-vertical>
            </v-col>
            <v-col cols="12" sm="12" lg="4" class="pl-1 pr-1">
                <i-card-vertical headerTitle="iseleltList">
                    <template v-slot:body>
                    </template>
                </i-card-vertical>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import iCardVertical from '@/components/common/iCardVertical.vue'

export default {
    name: 'componentTab',
    components: {
        'i-card-vertical': iCardVertical
    },
}
</script> 